({
	paths: {
		'text': '../lib/require/text',
		'durandal':'../lib/durandal/js',
		'plugins' : '../lib/durandal/js/plugins',
		'transitions' : '../lib/durandal/js/transitions',
		'knockout': '../lib/knockout/knockout-3.4.0',
		'validation': '../lib/knockout/knockout.validation',
		'bootstrap': '../lib/bootstrap/js/bootstrap.min',
		'material': '../lib/bootstrap/js/bootstrap-material-design',
		'jquery': '../lib/jquery/jquery-1.9.1',
		'print': '../lib/jquery/jQuery.print.min',
		'moment': '../lib/daterange/moment.min',
		'daterange': '../lib/daterange/daterange',
		'popper': '../lib/popper/popper',
		'sumoselect': '../lib/sumoselect/jquery.sumoselect.min',
		'owl': '../lib/owlcarousel/owl.carousel.min',
		'chartjs': '../lib/chartjs/chart.min',
		'sticky': '../lib/sticky/jquery.sticky-kit.min',
		'ua-parser': '../lib/ua-parser/ua-parser',
		'modals': 'viewmodels/modals/',
		'cleave': '../lib/cleave/cleave',
		'cookie': '../lib/jquery/jquery.cookie',
		'smallpop':'../lib/smallpop/dist/spop.min',
		'chosen':'../lib/chosen/chosen.jquery',
		'pdfjs/pdf': '../lib/pdfjs/pdf.min',
    'pdfjs/pdf.worker': '../lib/pdfjs/pdf.worker.min'
	},
	fileExclusionRegExp: /^(r|build)\.js$/,
})
;
define("build", function(){});

